
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)
// 用户路由
export default [
  {
    path: '/scratchDisks',
    name: 'ScratchDisks',
    meta: {
      title: '我的网盘',
      auth: true
    },
    component: _import('tools/scratch-disks')
  }
]
